import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useRootStore } from '../../../../../root/RootStoreHooks';

export const Nuvei3ds = observer(() => {
  const rootStore = useRootStore();
  const { billingEntry, threeDSecureEntry: { nuvei3ds } = {} } = rootStore.moduleStores;
  const { isLastStep } = rootStore.stepsManager;
  const { hasUserInput } = billingEntry?.creditCardData ?? {};
  useEffect(() => {
    if (nuvei3ds?.isEnabled) {
      if (isLastStep || hasUserInput) {
        nuvei3ds.initAuth();
      }
    }
  }, [nuvei3ds, nuvei3ds?.isEnabled, hasUserInput, isLastStep]);

  return null;
});
